import React from 'react'
import { Card } from 'components/Card'
import { ErrorBlock } from 'components/ErrorBlock'
import { NoResults } from 'components/NoResults'
import { Spinner } from 'components/Spinner'
import { Heading } from 'components/Heading'
import { CandidateSkillIntersect } from 'types'
import { parseSkillsByLevel, ParseSkillsByLevelOptions, skillLevelsWithInfo, useState } from 'utils'
import styled from 'styled-components'
import { CandidateSkillListItem } from './CandidateSkill.list.item'
import { candidateSkillsListStyles } from './CandidateSkill.list.styles'

const CandidateSkillListView = styled.div`
	${candidateSkillsListStyles}
`

export type OnSelectCandidateSkill = (candidateSkill: CandidateSkillIntersect) => void
export type OnNavToCandidateSkill = (candidateSkillId: number) => void

type CandidateSkillListProps = {
	className?: string
	skills?: CandidateSkillIntersect[] | null
	error?: any
	isLoading?: boolean
	showLevels?: boolean
	onSelectSkill?: OnSelectCandidateSkill
	onNavToSkill?: OnNavToCandidateSkill
	selectedSkillIds?: number[]
	view?: ParseSkillsByLevelOptions['view']
	noResultsText?: string
}

export const CandidateSkillList = ({
	skills,
	error,
	isLoading,
	className,
	showLevels,
	onNavToSkill,
	onSelectSkill,
	selectedSkillIds,
	view,
	noResultsText = 'No skills yet...',
}: CandidateSkillListProps) => {
	const skillsByLevel = skills && parseSkillsByLevel(skills, { view })
	const [lastSelectedId, setLastSelected] = useState<number | null>(null, 'lastSelectedId')

	return (
		<CandidateSkillListView
			levelColors={skillLevelsWithInfo.map(({ color }) => color)}
			className={`${className ? ` ${className}` : ''}`}
		>
			{isLoading ? <Spinner isOverlay={false} height='half' /> : null}

			{skillsByLevel?.length ? (
				skillsByLevel.map(level => {
					const { id, name, vettedSkills, unVettedSkills } = level
					const skills = [...vettedSkills, ...unVettedSkills]

					return (
						<div key={id} className={`skill-level level-${id}`}>
							<Heading displayType='dialog-heading'>{name}</Heading>
							<Card padBottom>
								{skills?.length ? (
									skills.map(skill => (
										<CandidateSkillListItem
											key={skill.candidateSkillId}
											skill={skill}
											showLevel={showLevels}
											onNav={
												onNavToSkill
													? () => {
															onNavToSkill(skill.candidateSkillId)
															setLastSelected(skill.candidateSkillId)
													  }
													: undefined
											}
											onSelect={
												onSelectSkill
													? () => {
															onSelectSkill(skill)
															setLastSelected(skill.candidateSkillId)
													  }
													: undefined
											}
											isLastSelected={lastSelectedId === skill.candidateSkillId}
											isSelected={selectedSkillIds?.includes(skill.candidateSkillId) ? true : false}
										/>
									))
								) : (
									<NoResults type='skills' display='inline' titleText='Nothing here yet...' />
								)}
							</Card>
						</div>
					)
				})
			) : error ? (
				<ErrorBlock error={error} />
			) : (
				<NoResults type='skills' titleText={noResultsText} />
			)}
		</CandidateSkillListView>
	)
}
